__turbopack_context__.v({
  "buttonSpinner": "Newsletter-module-scss-module__XQp1Aq__buttonSpinner",
  "checkbox": "Newsletter-module-scss-module__XQp1Aq__checkbox",
  "checkbox-error": "Newsletter-module-scss-module__XQp1Aq__checkbox-error",
  "checkmark": "Newsletter-module-scss-module__XQp1Aq__checkmark",
  "contentWrapper": "Newsletter-module-scss-module__XQp1Aq__contentWrapper",
  "copyWrapper": "Newsletter-module-scss-module__XQp1Aq__copyWrapper",
  "deckWrapper": "Newsletter-module-scss-module__XQp1Aq__deckWrapper",
  "description": "Newsletter-module-scss-module__XQp1Aq__description",
  "eyebrow": "Newsletter-module-scss-module__XQp1Aq__eyebrow",
  "form": "Newsletter-module-scss-module__XQp1Aq__form",
  "headline": "Newsletter-module-scss-module__XQp1Aq__headline",
  "inner": "Newsletter-module-scss-module__XQp1Aq__inner",
  "input": "Newsletter-module-scss-module__XQp1Aq__input",
  "inputLockup": "Newsletter-module-scss-module__XQp1Aq__inputLockup",
  "inputSuccess": "Newsletter-module-scss-module__XQp1Aq__inputSuccess",
  "inputWrap": "Newsletter-module-scss-module__XQp1Aq__inputWrap",
  "joinError": "Newsletter-module-scss-module__XQp1Aq__joinError",
  "list": "Newsletter-module-scss-module__XQp1Aq__list",
  "listLabel": "Newsletter-module-scss-module__XQp1Aq__listLabel",
  "listWrapper": "Newsletter-module-scss-module__XQp1Aq__listWrapper",
  "reCaptchaLegal": "Newsletter-module-scss-module__XQp1Aq__reCaptchaLegal",
  "root": "Newsletter-module-scss-module__XQp1Aq__root",
  "submitButton": "Newsletter-module-scss-module__XQp1Aq__submitButton",
  "submitButtonWrap": "Newsletter-module-scss-module__XQp1Aq__submitButtonWrap",
  "submitButtonWrap__isLoading": "Newsletter-module-scss-module__XQp1Aq__submitButtonWrap__isLoading",
  "submitButtonWrap__isSuccess": "Newsletter-module-scss-module__XQp1Aq__submitButtonWrap__isSuccess",
});
